var mySwiper = new Swiper('.swiper-container', {
  effect: 'fade',
  speed: 2000,
  autoplay: {
    delay: 5000,
  },
});

$('.icon-deli').on('click', function() {
  $(this).parents('.takeOut_listItem').find('.delivery_container').slideToggle();
});

$('#bigSmileBtn').on('click', function() {
  $('#bigSmile').fadeToggle();
});

$('#bigSmileClose').on('click', function() {
  $('#bigSmile').fadeOut();
});

$(function(){
  function animation(){
    $('.fadeInUp').each(function(){
      var target = $(this).offset().top;
      var scroll = $(window).scrollTop();
      var windowHeight = $(window).height();
      if (scroll > target - windowHeight){
        $(this).css('opacity','1');
        $(this).css('transform','translateY(0)');
      }
    });
  }
  animation();
  $(window).scroll(function (){
    animation();
  });
});

$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

$(function(){
  var pagetop = $('#page_top');
  // ボタン非表示
  pagetop.hide();
  // 100px スクロールしたらボタン表示
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      pagetop.fadeIn();
    } else {
      pagetop.fadeOut();
    }
  });
  pagetop.click(function () {
    $('body, html').animate({ scrollTop: 0 }, 500);
    return false;
  });
});

$(function(){
  $("#menuBtn").on("click", function(){
    $("#menu").slideToggle();
  });
  $(".menu-link").on("click", function(){
    $("#menu").slideToggle();
  });
  $(".cassette-card > .head").on("click", function () {
    $(this).next(".body").slideToggle();
  });
  $(".btn-close").on("click", function(){
    $(this).parent().slideToggle();
  });
});